import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IHealthIssue, IHealthIssueInitial } from "./healthIssueModel";
import {
  activeInactiveHealthIssue,
  createHealthIssue,
  deleteHealthIssue,
  getAllActiveHealthIssue,
  getAllHealthIssues,
  getHealthIssueById,
  updateHealthIssue,
} from "./services/healthIssue.services";

const initialState: IHealthIssueInitial = {
  loading: false,
  formLoading: false,
  error: "",
  HealthIssueList: [],
  HealthIssueID: null,
  HealthIssueDetail: {
    Name: "",
    IsActive: 1,
  },
};

export const healthIssueSlice = createSlice({
  name: "healthIssue",
  initialState,
  reducers: {
    clearHealthIssueDetails: (state) => {
      state.HealthIssueDetail = initialState.HealthIssueDetail;
    },
    setHealthIssueID: (state, action) => {
      state.HealthIssueID = action.payload;
    },
    clearHealthIssueID: (state) => {
      state.HealthIssueID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllHealthIssues.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHealthIssues.fulfilled,
      (state, action: PayloadAction<IHealthIssue[]>) => {
        state.loading = false;
        state.HealthIssueList = action.payload;
      }
    );
    builder.addCase(getAllHealthIssues.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HealthIssueList = [];
    });

    builder.addCase(getAllActiveHealthIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveHealthIssue.fulfilled,
      (state, action: PayloadAction<IHealthIssue[]>) => {
        state.loading = false;
        state.HealthIssueList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveHealthIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HealthIssueList = [];
    });

    builder.addCase(createHealthIssue.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createHealthIssue.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createHealthIssue.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateHealthIssue.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateHealthIssue.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateHealthIssue.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteHealthIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHealthIssue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHealthIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(activeInactiveHealthIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveHealthIssue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveHealthIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHealthIssueById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getHealthIssueById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.HealthIssueDetail = action.payload;
    });
    builder.addCase(getHealthIssueById.rejected, (state, action) => {
      state.formLoading = false;
      state.HealthIssueDetail = initialState.HealthIssueDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearHealthIssueDetails, setHealthIssueID, clearHealthIssueID } =
  healthIssueSlice.actions;
export default healthIssueSlice.reducer;
